import { NgModule, inject } from '@angular/core';
import { MAT_BUTTON_TOGGLE_DEFAULT_OPTIONS } from '@angular/material/button-toggle';
import { MATERIAL_SANITY_CHECKS } from '@angular/material/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';

import { FuseMediaWatcherModule } from './services/media-watcher/media-watcher.module';
import { FuseSplashScreenModule } from './services/splash-screen/splash-screen.module';
import { FuseUtilsModule } from './services/utils/utils.module';
@NgModule({
  imports: [FuseMediaWatcherModule, FuseSplashScreenModule, FuseUtilsModule],
  providers: [
    {
      // Disable 'theme' sanity check
      provide: MATERIAL_SANITY_CHECKS,
      useValue: {
        doctype: true,
        theme: false,
        version: true
      }
    },
    {
      // Use the 'fill' appearance on Angular Material form fields by default
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        appearance: 'fill'
      }
    },
    {
      // Preserve the pre-Material 20 button-toggle UI without selection checkmarks
      provide: MAT_BUTTON_TOGGLE_DEFAULT_OPTIONS,
      useValue: {
        hideSingleSelectionIndicator: true,
        hideMultipleSelectionIndicator: true
      }
    }
  ]
})
export class FuseModule {
  /**
   * Constructor
   */
  constructor() {
    const parentModule = inject(FuseModule, { optional: true, skipSelf: true });
    if (parentModule) {
      throw new Error(
        'FuseModule has already been loaded. Import this module in the AppModule only!'
      );
    }
  }
}
